export const API_URL = 'https://forkify-api.herokuapp.com/api/v2/recipes/';
export const TIMEOUT_SEC = 10
export const RES_PER_PAGE = 10
export const KEY = '90be4c44-81c8-403e-8c56-10bd9e0018d8';
export const MODAL_CLOSE_SEC = 2.5;